export default "__VITE_ASSET__BISkg7oR__"